import React, { Component } from "react";
import "./App.css";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/es/integration/react";
import Session, { IsAuthenticated, IsNotAuthenticated } from "./components/session";
import LoginScreen from "./screens/login-screen";
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import DashboardScreen from "./screens/dashboard-screen";
import TownsScreen from "./screens/towns-screen";
import MessagesScreen from "./screens/messages-screen";
import UsersScreen from "./screens/users-screen";
import TeamsScreen from "./screens/teams-screen";
import TrashDropsScreen from "./screens/trash-drops-screen";
import GreenUpDayScreen from "./screens/green-up-day-screen";
import "react-virtualized/styles.css";
import configureStore from "./store/configure-store";
import Splash from "./screens/splash-screen";
import ToolsScreen from "./screens/tools-screen";
import Layout from "./components/layout";

const { persistor, store } = configureStore(); // Using a persisted store

class App extends Component {
    render() {
        return (
            <Provider store={ store }>
                <PersistGate loading={ <Splash message={ "Loading..." }/> } persistor={ persistor }>
                    <Session>
                        <IsAuthenticated>
                            <Router>
                                <Layout>
                                    <Switch>
                                        <Route path="/dashboard">
                                            <DashboardScreen/>
                                        </Route>
                                        <Route
                                            path="/towns/:id?"
                                            render={
                                                ({ match }) => (<TownsScreen match={ match }/>)
                                            }
                                        />
                                        <Route path="/messages/:action?"><MessagesScreen/></Route>
                                        <Route
                                            path="/users/:id?"
                                            render={
                                                ({ match }) => (<UsersScreen match={ match }/>)
                                            }
                                        />
                                        <Route
                                            path="/teams/:id?"
                                            render={
                                                ({ match }) => (<TeamsScreen match={ match }/>)
                                            }
                                        />
                                        <Route
                                            path="/trash-drops/:id?"
                                            render={
                                                ({ match }) => (<TrashDropsScreen match={ match }/>)
                                            }
                                        />
                                        <Route path="/green-up-day"><GreenUpDayScreen/></Route>
                                        <Route path="/tools"><ToolsScreen/></Route>

                                        <Redirect to={ "/dashboard" }/>
                                    </Switch>
                                </Layout>
                            </Router>
                        </IsAuthenticated>
                        <IsNotAuthenticated>
                            <LoginScreen/>
                        </IsNotAuthenticated>
                    </Session>
                </PersistGate>
            </Provider>
        );
    }
}

export default App;
